export default {
    user:                   null,
    objects:                null,
    object_packets:         null,
    tinyObjects:            { all: null },
    lastOpenedPage:         1,
    editObject:             null,
    numOfPages:             null,
    numOfPagesForRequests:  null,
    locales:                null,
    impressum:              null,
    availableFilters:       null,
    objectsFilters:         {},
    loading:                false,
    notifications_count:    0,
    assessment_count:       0,
    queries:                null,
    overview:               null,
    sepaInfoMissing:        0,
    sepaDetails:            null
}
